/* ============================================================
   BONHEUR - Contador de la galeria de producto
   BigStudio 2026

   POR QUE EXISTE
   En movil la galeria de Horizon apila las fotos una debajo de
   otra. En un cheesecake son QUINCE imagenes, o sea quince
   pantallas de scroll antes de llegar al precio. La hoja movil la
   convierte en un carrusel a sangre con encaje por foto, y este
   archivo le pone lo unico que un carrusel necesita para no
   desorientar: saber en cual vas.

   Sin puntos y sin flechas. Con quince fotos, quince puntos son
   quince objetivos de 8 px que nadie acierta; un contador ocupa
   una esquina y se lee de una.

   Si este archivo no carga, la galeria sigue siendo un carrusel
   deslizable y no queda ningun control muerto.
   ============================================================ */

(function () {
  'use strict';

  var MIN = 2; /* con una sola foto no hay nada que contar */

  function montar(galeria) {
    if (!galeria || galeria.__bhConteo) return;

    var slides = galeria.querySelectorAll('li');
    if (slides.length < MIN) return;

    /* Solo donde de verdad se desliza. En escritorio la galeria
       es una rejilla y el contador seria una mentira. */
    if (window.getComputedStyle(galeria).overflowX !== 'auto') return;

    var padre = galeria.parentElement;
    if (!padre) return;
    if (window.getComputedStyle(padre).position === 'static') {
      padre.style.position = 'relative';
    }

    var marca = document.createElement('span');
    marca.className = 'bh-conteo';
    marca.setAttribute('aria-hidden', 'true');
    padre.appendChild(marca);

    function pintar() {
      var ancho = galeria.clientWidth;
      if (!ancho) return;
      var i = Math.round(galeria.scrollLeft / ancho) + 1;
      if (i < 1) i = 1;
      if (i > slides.length) i = slides.length;
      marca.textContent = i + ' / ' + slides.length;
    }

    var pendiente = false;
    galeria.addEventListener(
      'scroll',
      function () {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(function () {
          pendiente = false;
          pintar();
        });
      },
      { passive: true }
    );

    if ('ResizeObserver' in window) new window.ResizeObserver(pintar).observe(galeria);

    galeria.__bhConteo = true;
    pintar();
  }

  function arrancar(ctx) {
    var g = (ctx || document).querySelectorAll('.media-gallery__grid');
    for (var i = 0; i < g.length; i++) montar(g[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
  } else {
    arrancar(document);
  }

  document.addEventListener('shopify:section:load', function (e) { arrancar(e.target); });

  /* El ancho de la galeria cambia al girar el telefono y con eso
     cambia si es carrusel o rejilla. */
  window.addEventListener('orientationchange', function () {
    window.setTimeout(function () { arrancar(document); }, 300);
  });
})();
